export default __webpack_public_path__ + "static/media/arrow-right.a5e039a7.svg";